const SERVICE_UUID = "12345678-1234-1234-1234-123456789012";
const CHARACTERISTIC_UUID = "87654321-4321-4321-4321-210987654321";

const RESPONSE_TIMEOUT_MS = 8000;

const sleep = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

const decodeValue = (value) => {
    if (!value) {
        return "";
    }

    if (typeof value === "string") {
        return value;
    }

    if (value.buffer) {
        const bytes = new Uint8Array(value.buffer, value.byteOffset || 0, value.byteLength || value.buffer.byteLength);
        return new TextDecoder().decode(bytes).trim();
    }

    return "";
};

const writeText = async (characteristic, text) => {
    const bytes = new TextEncoder().encode(text);
    await characteristic.writeValue(bytes);
};

const waitForResult = async (characteristic) => {
    await characteristic.startNotifications();

    return new Promise((resolve, reject) => {
        const handleChange = (event) => {
            const value = decodeValue(event.target.value);
            if (!value || value === "*" || value === "Cleared") {
                return;
            }

            if (value === "OK" || value === "UNLOCKED") {
                window.clearTimeout(timeoutId);
                characteristic.removeEventListener("characteristicvaluechanged", handleChange);
                resolve("OK");
            } else if (value === "FAIL") {
                window.clearTimeout(timeoutId);
                characteristic.removeEventListener("characteristicvaluechanged", handleChange);
                resolve("FAIL");
            }
        };

        const timeoutId = window.setTimeout(async () => {
            characteristic.removeEventListener("characteristicvaluechanged", handleChange);
            try {
                const fallback = decodeValue(await characteristic.readValue());
                if (fallback === "OK" || fallback === "UNLOCKED") {
                    resolve("OK");
                    return;
                }
                if (fallback === "FAIL") {
                    resolve("FAIL");
                    return;
                }
            } catch (_) {
                // Ignore fallback read failure and report timeout.
            }
            reject(new Error("BLE не відповів вчасно"));
        }, RESPONSE_TIMEOUT_MS);

        characteristic.addEventListener("characteristicvaluechanged", handleChange);
    });
};

export const isBleUnlockSupported = () => {
    return typeof navigator !== "undefined" && Boolean(navigator.bluetooth?.requestDevice);
};

export const unlockViaBlePin = async (pin) => {
    const normalizedPin = String(pin || "").trim();
    if (!/^\d{4,8}$/.test(normalizedPin)) {
        throw new Error("PIN має містити 4-8 цифр");
    }

    if (!isBleUnlockSupported()) {
        throw new Error("У цьому браузері або збірці BLE недоступний");
    }

    let device;
    try {
        device = await navigator.bluetooth.requestDevice({
            filters: [{ services: [SERVICE_UUID] }],
            optionalServices: [SERVICE_UUID],
        });

        const server = await device.gatt.connect();
        const service = await server.getPrimaryService(SERVICE_UUID);
        const characteristic = await service.getCharacteristic(CHARACTERISTIC_UUID);
        const resultPromise = waitForResult(characteristic);

        await writeText(characteristic, "*");
        await sleep(150);
        await writeText(characteristic, `${normalizedPin}#`);

        const result = await resultPromise;
        if (result !== "OK") {
            throw new Error("Невірний BLE PIN");
        }
    } finally {
        if (device?.gatt?.connected) {
            device.gatt.disconnect();
        }
    }
};